import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRef } from 'vue';
import { RcStatusBadgeProps } from './types';
import { useStatusColors } from '@components/utils/status';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcStatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f61b0688": (_unref(backgroundColor)),
  "v4c55d004": (_unref(borderColor)),
  "v7de42546": (_unref(textColor))
}))

const props = __props;

const status = toRef(props, 'status');
const { backgroundColor, borderColor, textColor } = useStatusColors(status, 'outlined');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rc-status-badge", {[props.status]: true}])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})